<!--
화면배율 조정 컴포넌트
- 컴포넌트를 삽입하는순간 전체 html 문서의 배율이 조정된다.
-------------------
-->
<template>
    <div class="root">
        <div class="uk-margin-small-right">
            <i class="material-icons">aspect_ratio</i>
            화면배율: {{ screenRatioText }}
        </div>
    </div>
</template>

<script>
    import screenRatioAble from "./screen-ratio-able.vue";

    export default {
        mixins: [
            screenRatioAble,
        ],
        props: {
        },
        data: function () {
            return {
            };
        },
        computed: {
        },
        methods: {

        },
    }
</script>


<style lang="scss" scoped>

</style>